import { Facebook, Instagram, Linkedin, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import FaleComEspecialistaForm from './ui/FaleComEspecialistaForm';
const Footer = () => {
  return <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo e Descrição */}
          <div className="lg:col-span-1 md:mb-0">
            <Link to="/" className="flex items-center space-x-2 mb-2 md:mb-4">
              <img src="/lovable-uploads/37042df7-136b-45af-ad35-e1168c599a3d.webp" alt="Thopen Energy" className="h-8 w-auto brightness-0 invert" width={500} height={152} />
            </Link>
            <p className="text-gray-400 mb-2 md:mb-4">
              A maior plataforma de energia livre do Brasil em número de unidades consumidoras.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/thopenergy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-400 hover:text-thopen-yellow transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/thopenergy" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-thopen-yellow transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/thopenergy/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-400 hover:text-thopen-yellow transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Soluções */}
          <nav aria-label="Soluções">
            <h3 className="text-lg font-semibold mb-4">Soluções</h3>
            <div className="space-y-4">
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Quero Economizar na Conta de Luz</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/para-sua-casa" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Para Sua Casa
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/para-sua-empresa" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Para Sua Empresa
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/o-que-voce-precisa/quero-economizar-na-conta-de-luz/simule-sua-economia" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Simule sua Economia
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Geração Distribuída</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/geracao-compartilhada" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Geração Compartilhada
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/geracao-remota" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Geração Remota
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/nossos-produtos-e-servicos/geracao-distribuida/gestao-backoffice" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Gestão Backoffice
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Mercado Livre de Energia</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Mercado Livre de Energia
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/nossos-produtos-e-servicos/mercado-livre-de-energia/gestao-backoffice" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Gestão Backoffice
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">Gestão e Eficiência Energética</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/solucoes/gestao-e-eficiencia-energetica/diagnostico-de-contas-de-energia" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Diagnóstico de Contas de Energia
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/gestao-e-eficiencia-energetica/ressarcimento-de-valores-indevidos" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Ressarcimento de Valores Indevidos
                    </Link>
                  </li>
                  <li>
                    <Link to="/solucoes/gestao-e-eficiencia-energetica/gestao-completa-de-faturas" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                      Gestão Completa de Faturas
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Entenda sua Energia */}
          <nav aria-label="Entenda sua energia">
            <h3 className="text-lg font-semibold mb-4">Entenda sua Energia</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/entenda-sua-energia/descomplique-sua-conta-de-luz" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Descomplique sua conta de luz
                </Link>
              </li>
              <li>
                <Link to="/entenda-sua-energia/beneficios-da-energia-limpa" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Benefícios da Energia Limpa
                </Link>
              </li>
              <li>
                <Link to="/entenda-sua-energia/o-mercado-livre-de-energia-guia-completo" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  O Mercado Livre de Energia: Guia Completo
                </Link>
              </li>
              <li>
                <Link to="/entenda-sua-energia/como-a-thopen-gera-economia-na-conta-de-luz" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Como a Thopen Gera Economia
                </Link>
              </li>
              {/* <li>
                <Link to="/entenda-sua-energia/queda-de-energia" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Queda de energia
                </Link>
              </li> */}
              <li>
                <Link to="/entenda-sua-energia/qualidade-do-fornecimento" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Qualidade do fornecimento
                </Link>
              </li>
              <li>
                <Link to="/entenda-sua-energia/disponibilizacao-da-fatura" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Disponibilização da fatura
                </Link>
              </li>
              {/* <li>
                <Link to="/entenda-sua-energia/queima-de-equipamento" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Queima de equipamento
                </Link>
              </li> */}
            </ul>
          </nav>

          {/* Quem Somos e Insights */}
          <nav aria-label="Empresa">
            <h3 className="text-lg font-semibold mb-4">Quem Somos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/quem-somos" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link to="/quem-somos/nossas-usinas" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Nossas Usinas
                </Link>
              </li>
              <li>
                <Link to="/quem-somos/trabalhe-conosco" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Trabalhe Conosco
                </Link>
              </li>
            </ul>
            <h3 className="text-lg font-semibold mb-4 mt-6">Insights</h3>
            <ul className="space-y-2">
              <li>
                <Link to="https://blog.thopenergy.com.br" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="https://blog.thopenergy.com.br/saiu-na-midia" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-thopen-yellow transition-colors text-sm">
                  Saiu na Mídia
                </Link>
              </li>
            </ul>
          </nav>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <div className="space-y-3">
              
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-thopen-yellow" />
                <span className="text-gray-400 text-sm">4000 2022</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-thopen-yellow flex-shrink-0" />
                <span className="text-gray-400 text-sm">Av. Rebouças, 2728 - Rebouças, São Paulo - SP, 05402-500</span>
              </div>
            </div>
            <FaleComEspecialistaForm
              iconDisplay='none'
              text='Entre em contato'
              buttonClassName='inline-block mt-4 bg-gradient-to-r from-thopen-pink to-thopen-yellow text-white px-4 py-2 rounded-lg text-sm font-medium hover:shadow-lg transition-all duration-200'
            />
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col items-center gap-4">
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/politica-privacidade" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos-uso" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Termos
              </Link>
              <Link to="/politica-anticorrupcao" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Política Anticorrupção
              </Link>
              <Link to="/codigo-conduta-etica" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Código de Conduta e Ética
              </Link>
              <a href="https://www.canalconfidencial.com.br/thopenergy/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Canal de Denúncias
                <span className="sr-only"> (abre em nova aba)</span>
              </a>
              <a href="https://ri.thopenergy.com.br/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-thopen-yellow text-sm transition-colors">
                Relação com Investidores
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              © 2026 Thopen Energy. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;